module.exports = __webpack_public_path__ + "static/img/图片16.cc349fe3.png";